<template>
  <div
    v-if="pageLoading"
    class="m-3"
  >
    <placeholder-content :is-load="true" />
  </div>
  <div
    v-else-if="!hasPermission"
    class="m-3"
  >
    <access-denied/>
  </div>
  <div
    v-else
  >
    <div class="d-flex justify-content-between border-bottom mb-3">
      <ul class="nav nav-custom">
        <li class="nav-item">
          <a class="nav-link active">
            {{ $t('All') }}
            <span class="badge rounded-pill bg-primary">
              {{ datatable.total }}
            </span>
          </a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link disabled" tabindex="-1" aria-disabled="true">Disabled</a>
        </li> -->
      </ul>

      <column-toggle
        :headers="allHeaders"
        storage-key="suppliers.columns"
        v-model="visibleColumns"
      />
    </div>
    <div class="d-flex justify-content-start mx-3 flex-column flex-sm-row">
      <div class="btn-group btn-group-sm me-sm-2 mb-3">
        <!-- <button
          type="button"
          class="btn btn-sm btn-primary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa-solid fa-circle-plus me-2" />
          {{ $t('Create') }}
        </button>
        <ul class="dropdown-menu">
          <li>
            <button
              class="dropdown-item"
              type="button"
              @click="() => {
                form.open = true;
                form.viewOnly = false;
                form.type = 'CREATE';
              }"
            >
              <span
                class="badge bg-primary me-2 p-0"
                style="width: 20px; line-height: 20px;"
              >
                <i class="fas fa-box" />
              </span>
              {{ $t('Simple') }}
            </button>
          </li>
          <li>
            <button
              class="dropdown-item"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasSimple"
              aria-controls="offcanvasSimple"
            >
              <span
                class="badge bg-success me-2 p-0"
                style="width: 20px; line-height: 20px;"
              >
                <i class="fas fa-boxes-packing" />
              </span>
              {{ $t('Configurable') }}
            </button>
          </li>
          <li>
            <button
              class="dropdown-item"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasSimple"
              aria-controls="offcanvasSimple"
            >
              <span
                class="badge bg-danger me-2 p-0"
                style="width: 20px; line-height: 20px;"
              >
                <i class="fas fa-boxes-stacked" />
              </span>
              {{ $t('Set') }}
            </button>
          </li>
        </ul> -->
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="() => {
            form.open = true;
            form.viewOnly = false;
            form.type = 'CREATE';
          }"
        >
          <i class="fa-solid fa-circle-plus me-2" />
          {{ $t('Create') }}
        </button>
      </div>

      <div class="custom-input-group input-group input-group-sm me-sm-2 mb-3 w-auto">
        <input
          type="search"
          class="form-control"
          :placeholder="$t('search')+'...'"
          aria-label="Search"
          aria-describedby="search-addon"
          v-model.trim="params.search"
          @keyup.enter="fetchData"
        >
        <button
          class="input-group-text"
          type="button"
          @click="fetchData"
        >
          <i class="fas fa-search" />
        </button>
      </div>
      <per-page
        @per-page="setPerPage"
      />
    </div>
    <vue3-easy-data-table
      v-model:server-options="datatable.serverOptions"
      ref="dataTable"
      :headers="visibleHeaders"
      :items="datatable.items"
      :loading="datatable.loading"
      :server-items-length="datatable.total"
      :theme-color="'#515151'"
      :hide-footer="false"
      :hide-rows-per-page="true"
      :empty-message="$t('No Available Data')"
      :table-min-height="null"
      :body-item-class-name="'align-top py-1 px-2'"
      buttons-pagination
      table-class-name='customize-table'
      header-text-direction="center"
    >
      <template #item-branch="item">
        <div class="text-start">
          {{ item.branch? item.branch: '-' }}
        </div>
      </template>
      <template #item-tax_id="item">
        <div class="text-start">
          {{ item.tax_id? item.tax_id: '-' }}
        </div>
      </template>
      <template #item-created_at="item">
        <div class="text-center">
          {{ formatDateTime(item.created_at) }}
        </div>
      </template>
      <template #item-created_by="item">
        <div class="text-end">
          {{ item.created_by }}
        </div>
      </template>
      <template #item-action="item">
        <div class="icon-link custom-actions">
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="() => {
                formInfo.open = true;
                formInfo.supplierId = item.id;
              }"
            >
              <i class="fa-solid far fa-eye" />
            </button>
            <template #content>
              <div>{{ $t('View') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="() => {
                form.open = true;
                form.viewOnly = false;
                form.supplierId = item.id;
                form.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
            </button>
            <template #content>
              <div>{{ $t('Edit') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="handleDelete(item.id)"
            >
              <i class="fa-solid fa-trash-can" />
            </button>
            <template #content>
              <div>{{ $t('Delete') }}</div>
            </template>
          </popper>
          <!-- <button type="button" data-original-title="Delete" class="btn btn-outline-primary btn-sm btn-icon">
            <i class="fa-solid fa-trash-can" />
          </button> -->
        </div>
      </template>
      <template #loading>
        <i class="fa-solid fa-spinner fa-spin fa-2xl" />
      </template>
    </vue3-easy-data-table>
    <offcanvas-form
      v-if="form.open"
      :type="form.type"
      :supplier-id="form.supplierId"
      :view-only="form.viewOnly"
    />
    <offcanvas-info
      v-if="formInfo.open"
      :supplier-id="formInfo.supplierId"
    />
    <div
      class="modal fade"
      id="modalImage"
      ref="modalImage"
      aria-labelledby="modalImageLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <img
          :src="modalImage.image"
          class="d-block w-100"
          data-bs-dismiss="modal"
        >
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { Suppliers } from '@/services/endpoint/suppliers.service';
import FieldsDef from "./assets/template/datatable/FieldsDef";
import OffcanvasForm from './OffcanvasForm.vue';
import OffcanvasInfo from './OffcanvasInfo.vue';
import ColumnToggle from '@/components/shared/ColumnToggle.vue';
import { loadVisibleColumns } from '@/utils/columnToggle';
import moment from "moment";
import PerPage from '@/plugins/PerPage.vue';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Popper from "vue3-popper";
import numeral from 'numeral';

export default {
  data() {
    return {
      form: {
        open: false,
        type: 'CREATE',
        supplierId: 0,
        viewOnly: false
      },
      formInfo: {
        open: false,
        supplierId: 0,
      },
      formUnusable: {
        open: false,
        supplierId: 0,
      },
      pageLoading: false,
      hasPermission: false,
      datatable: {
        loading: false,
        headers: FieldsDef,
        items: [],
        total: 0,
        serverOptions: {
          page: 1,
          rowsPerPage: 10
        }
      },
      params: {
        limit: 10,
        page: 1,
        search: ''
      },
      modalImage: {
        open: false,
        image: ''
      },
      showCost: [],
      visibleColumns: loadVisibleColumns('suppliers.columns', FieldsDef(t => t))
    }
  },
  filters: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
  },
  components: {
    Vue3EasyDataTable,
    AccessDenied,
    OffcanvasForm,
    OffcanvasInfo,
    ColumnToggle,
    PerPage,
    PlaceholderContent,
    Popper
  },
  computed: {
    allHeaders() {
      return this.datatable.headers(this.$t);
    },
    visibleHeaders() {
      return this.allHeaders.filter(h => !h.togglable || this.visibleColumns.includes(h.value));
    }
  },
  async mounted() {
    this.pageLoading = true;
    await this.fetchData();
    this.pageLoading = false;
  },
  methods: {
    async handleDelete(id) {
      try {
        let self = this;
        let title = this.$t("Delete Supplier") + '?';
        let html = this.$t("You will not be able to undo this action.");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Suppliers.delete(id)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Supplier Success!'));
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async fetchData() {
      this.datatable.loading = true;
      var queryString = '?' + $.param(this.params);
      await Suppliers.list(queryString).then(res => {
        this.datatable.items = res.data.data;
        this.datatable.total = res.data.meta.total;
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
      });

      this.datatable.loading = false;
      return;
    },
    setPerPage(perPage) {
      this.params.limit = perPage;
      this.$refs.dataTable.updateRowsPerPageActiveOption(perPage);
      this.fetchData();
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async showImage(image) {
      this.modalImage.image = image;
      $(this.$refs.modalImage).modal('show');
    }
  },
  watch: {
    "datatable.serverOptions" (nval, oval) {
      delete this.params.sort;
      this.params.page = nval.page;
      this.params.limit = nval.rowsPerPage;
      if (nval.sortBy && nval.sortType) this.params.sort = nval.sortBy + "|" + nval.sortType;
      this.fetchData();
    }
  }
}
</script>
